import React, { useMemo } from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';
import {
  findSIBeneficiary,
  SIPayBeneficiaryResponse,
  TpBankAccount,
} from 'services/thirdParty';
import { isNil, noop } from 'lodash';

export type SIBeneficiarySelectProps = SelectProps<any> & {
  tpid?: String;
  maintpid?: string;
  ctrid?: number;
  bankaccount?: boolean;
  onSelected?: (bf: SIPayBeneficiaryResponse) => void;
  allowClear?: boolean;
};

const SIBeneficiarySelect = ({
  tpid,
  value,
  bankaccount,
  onChange = noop,
  onSelected,
  allowClear,
  maintpid,
  ctrid,
  ...props
}: SIBeneficiarySelectProps) => {
  const params = useMemo(
    () => ({
      tpid: tpid,
      role: 'SUPPLIER',
      ctrid: ctrid,
    }),
    [ctrid, tpid]
  );

  const { data, isFetching } = useQuery(
    ['findSIBeneficiary', params], //params removed to prevent autorefresh
    () =>
      findSIBeneficiary({
        tpid: maintpid ? Number(maintpid) : Number(params.tpid),
        role: params.role,
        ctrid: params.ctrid,
      }),
    {
      enabled: !isNil(tpid) && !isNaN(Number(tpid)),
      staleTime: MINUTE,
    }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(data?.list?.find((item) => item.tpid === value)!);
    }
  };

  return bankaccount ? (
    <Select
      allowClear={allowClear}
      value={!isNaN(Number(value)) ? Number(value) : value}
      onChange={handleChange}
      loading={isFetching}
      {...props}
    >
      {data?.list
        ?.find((tp) => tp.tpid === Number(tpid))
        ?.tpbklist?.map((bank: TpBankAccount, index) => (
          <Select.Option value={bank.tpbkid} key={index}>
            {bank.tpiban}
          </Select.Option>
        ))}
    </Select>
  ) : (
    <Select
      allowClear={allowClear}
      value={!isNaN(value) ? Number(value) : value}
      onChange={handleChange}
      loading={isFetching}
      {...props}
    >
      {data?.list?.map((beneficiary: SIPayBeneficiaryResponse, index) => (
        <Select.Option value={beneficiary.tpid} key={index}>
          {beneficiary.tpname}
        </Select.Option>
      ))}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default SIBeneficiarySelect;
